import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { TokenResource } from "@sarva/api-client";
import { exchangeLaunchAssertion } from "../api/launch";

/** doc 27 §5: the launch exchange, as a Query mutation. See `exchangeLaunchAssertion`. */
export function useLaunch() {
  const queryClient = useQueryClient();

  return useMutation<TokenResource, unknown, string>({
    mutationFn: (assertion) => exchangeLaunchAssertion(assertion),
    // (H) Never retried: a second attempt with the same assertion is a replay and the API
    // refuses it, so a retry could only turn a transient failure into a certain one.
    retry: 0,
    onSuccess: () => {
      // A new identity invalidates everything a previous session cached in this tab.
      queryClient.clear();
    },
  });
}
